var scrollAnimationElm = document.querySelectorAll('.sa');
var scrollAnimationFunc = function () {
    for (var i = 0; i < scrollAnimationElm.length; i++) {
        var triggerMargin = 100;
        if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
            scrollAnimationElm[i].classList.add('appearance');
        }
    }
}
window.addEventListener('load', scrollAnimationFunc);
window.addEventListener('scroll', scrollAnimationFunc);

$(function () {
    var $setElem = $('.switch'),
        pcName = 'PC',
        spName = 'MOB',
        replaceWidth = 768;

    $setElem.each(function () {
        var $this = $(this);
        function imgSize() {
            if (window.innerWidth > replaceWidth) {
                $this.attr('src', $this.attr('src').replace(spName, pcName)).css({ visibility: 'visible' });
            } else {
                $this.attr('src', $this.attr('src').replace(pcName, spName)).css({ visibility: 'visible' });
            }
        }
        $(window).resize(function () { imgSize(); });
        imgSize();
    });

});